/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";

const useDefaultAddress = ({
	form, campusList,
	isUpdate
}) => {
	const { campusId, spaceOutOfCampus } = form.value;
	useEffect(() => {
		if (!spaceOutOfCampus)
			fillDefaultAddress();
	}, [campusId, spaceOutOfCampus]);
	function fillDefaultAddress() {
		if (
			!campusId ||
			!campusList.length ||
			!isUpdate
		) return;
		const defaultAddress = campusList
			.find(({ id }) => campusId === id)
			?.address || null;
		form.change("address", defaultAddress);
	}
}

export default useDefaultAddress;